<template lang="pug">
section
  s-page-title(title='Категории блога')
    template(slot='extension')
      v-btn(@click='onEdit()' color='primary' depressed) Добавить
  v-card
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      :total-items='total'
      :pagination='dataFilter'
      @update:pagination='updatePagination'
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer' @click='onEdit(props.item)')
          td {{ props.item.id }}
          td {{ props.item.name }}
          td(class='text-xs-right wrapless crud-tools')
            v-btn(icon @click.stop='onDelete(props.item)')
              v-icon(small) delete_outline
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

export default {
  data: () => ({
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '0%',
        sortable: true
      },
      {
        text: 'Название категории',
        align: 'left',
        sortable: true,
        value: 'name'
      },
      {
        text: '',
        align: 'left',
        width: '0%',
        sortable: false
      }
    ],
    sorting: {
      opened: false,
      resource: 'dictionary/blogcategories',
      itemValue: 'id',
      itemText: 'name'
    }
  }),

  created() {
    this.fetch()
  },

  methods: {
    updatePagination(pagination) {
      this.setDataFilter(pagination)
      this.fetch()
    },

    onEdit({ id } = {}) {
      this.$router.push({
        name: 'Seo.Categories.Edit',
        params: { id }
      })
    },

    fetch() {
      this.fetchList({
        config: {
          params: this.dataFilter
        }
      })
    },

    async onDelete({ id }) {
      if (await this.$confirm('Вы уверены?')) {
        try {
          await this.destroy({ id })
          this.fetch()
        } catch (e) {
          this.$root.showSnack('Ошибка удаления')
        }
      }
    },

    ...mapActions('seo/categories', ['fetchList', 'destroy']),
    ...mapMutations('seo/categories', ['setDataFilter'])
  },

  computed: {
    ...mapState('seo/categories', ['total', 'dataFilter']),
    ...mapGetters('seo/categories', ['list', 'isLoading']),
  }
}
</script>
